<template>
  <v-menu v-bind="$props" v-on="$listeners" :close-on-content-click="false">
    <!-- pass through scoped slots -->
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>

    <!-- pass through normal slots -->
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-menu>
</template>

<script>
import { VMenu } from "vuetify/lib";

export default {
  name: "SMenu",
  extends: VMenu,
};
</script>

<style></style>
